import type {AiChatGeneratedAsset, AiChatGeneratedAssetFilter} from '@AiChat/ai-chat.types';

export const AI_CHAT_GENERATED_ASSET_ADDED_EVENT = 'ai-chat-generated-asset-added';

export const getGeneratedAssets = async (filter: AiChatGeneratedAssetFilter, limit: number, offset: number): Promise<AiChatGeneratedAsset[]> => {
  return (await window.PMW.readLocal('ai/getGeneratedAssets', {filter, limit, offset})) as AiChatGeneratedAsset[];
};

export const hasAnyGeneratedAssets = async (): Promise<boolean> => {
  return (await window.PMW.readLocal('ai/hasGeneratedAssets')) as boolean;
};

export const getShouldShowAssetsIntroSubtitle = async (): Promise<boolean> => {
  const result = (await window.PMW.readLocal('ai/shouldShowAssetsIntroSubtitle')) as {shouldShow: boolean};
  return result.shouldShow;
};

export const recordAssetsIntroSubtitleView = async (): Promise<boolean> => {
  const result = (await window.PMW.writeLocal('ai/recordAssetsIntroSubtitleView', {})) as {shouldShow: boolean};
  return result.shouldShow;
};

export const dispatchAiChatGeneratedAssetAdded = (): void => {
  window.dispatchEvent(new CustomEvent(AI_CHAT_GENERATED_ASSET_ADDED_EVENT));
};
